import React from "react";
import Style from "./TransactionInfo.module.css";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";
import { convertToTimestamp } from "../../../../Utils/ConvertStamp";
import { convertDate } from "../../../../Utils/Helper/Helper";

const TransactionInfo = ({ data }) => {
  const transactionSituationHandler = (item) => {
    const amount = parseFloat(item.amount);
    switch (item.status) {
      case "1":
        if (amount > 0) {
          return "شارژ حساب";
        } else {
          return "برداشت از حساب";
        }
      case "0":
        return "قسط پرداخت نشده";
      case "2":
        return "قسط پرداخت شده";

      default:
        break;
    }
  };
  const transactionSituationStyle = (item) => {
    const amount = parseFloat(item.amount);
    switch (item.status) {
      case "1":
        if (amount > 0) {
          return "#007be0";
        } else {
          return "#c20078";
        }
      case "0":
        return "gray";
      case "2":
        return "green";

      default:
        break;
    }
  };

  return (
    <>
      {data?.map((item) => (
        <section
          key={item.id}
          className={Style.transactionCard}
          style={{ border: `1px solid ${transactionSituationStyle(item)}` }}
        >
          <h5 style={{ background: transactionSituationStyle(item) }}>
            وضعیت: {transactionSituationHandler(item)}
          
          </h5>
          <div className={Style.transactionCardInfo}>
            <p>تاریخ :{convertDate(item.date, false)}</p>
            <p>
              مبلغ:
              <strong style={{ color: "green" }}>
                {separate(item.amount)} تومان
              </strong>
            </p>
          </div>
          
        </section>
      ))}
    </>
  );
};

export default TransactionInfo;
